import styled from 'styled-components';

import { colors } from '~/styles/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0 32px;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 10px 16px;
  border: 1px solid ${colors.GreyDefaultCardBorder};
  border-radius: 8px;
  background-color: ${colors.White};
`;

export const PagePathLabel = styled.span`
  flex: 1;
  min-width: 200px;
  font-family: SFMono-Regular, Consolas, 'Liberation Mono', monospace;
  font-size: 12px;
  color: ${colors.Grey400};
  overflow-wrap: anywhere;
`;

export const ToolbarButton = styled.button`
  padding: 6px 14px;
  border: 1px solid ${colors.Blue300};
  border-radius: 6px;
  background-color: ${colors.White};
  color: ${colors.Blue300};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    border-color: ${colors.Grey200};
    color: ${colors.Grey200};
    cursor: default;
  }
`;

export const AutoRefreshLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${colors.Grey400};
  cursor: pointer;
`;

export const ErrorBox = styled.div`
  padding: 14px 16px;
  border: 1px solid ${colors.Pink200};
  border-radius: 8px;
  background-color: ${colors.LightRed};
  color: ${colors.Pink300};
  font-size: 13px;
`;

export const ContentFrame = styled.iframe`
  width: 100%;
  border: 1px solid ${colors.GreyDefaultCardBorder};
  border-radius: 8px;
  background-color: ${colors.White};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 0;
`;
